import UserAuthenticationService from './UserAuthenticationService';

export default UserAuthenticationService;
